import * as ComponentConstants from "../constants/ComponentConstants";

export default {
	// initiële state bij het starten van de app.
	// Evt defaults in opnemen
	ajaxCounter: 0,
	exception: {
		exception: null,
		redirectToExceptionPage: false
	},
	settings: {
		apiRoot: '', // root to the api site, including /api
		siteRoot: '', // root to the portal
		subsidiesWebAppRoot: '', // root to the parent subsidies app
		helpdeskContactLink: "",
		sportDBUrl: '',
		fileTypes: {},
		maxAllowedContentLength: "",
		accountId: "",
		accountType: "",
		disabled: false
	},
	validatieStatussen: [],
	layout: {
		pageHeaderTitle: "",
		pageHeaderSubtitle: "",
		activeTopNavItemId: "1",
		showHeader: false,
		showTopNav: false,
		showBeads: false,
		scope: "default",
		topNavTabsSet: false,
		topNavTabSettings: [],
		topNavPrefix: "",
		showSideNav: false,
		sideNavItems: [], // {id: "1", display: "SideNav Example 1", linkEnabled: true }
		sideNavPrefix: ""
	},
	referentie: {
		landen: [],
		gemeenten: [],
		postcodes: [],
		rechtspersoonlijkheidTypes: [],
		redenVanStatus: [],
		klachtenBronnen: [],
		initiatieven: [],
		sectoren:[],
		profitNonProfits: [],
		preventieDiensten:[],
		aangeslotenBijs: []
	},
	adressen: {
		gemeenten: []
	}
};
